import { retrieveCsrfToken } from '@services/auth'
import {
  sendTradeApplyRequest,
  sendUploadTradeDocumentRequest,
  TradeApplicationDTO,
  UploadTradeDocumentDTO,
} from '@services/trade'
import { trackTradeProgram } from '@utils/analytics/events'
import { Dispatch, SetStateAction } from 'react'

interface ApplyProps extends TradeApplicationDTO {
  setError: Dispatch<SetStateAction<string>>
}

interface UploadTradeDocumentProps extends UploadTradeDocumentDTO {
  setError: Dispatch<SetStateAction<string>>
  setStatus: Dispatch<SetStateAction<number | null>>
}

export const useTrade = () => {
  const apply = async ({ setError, ...props }: ApplyProps) => {
    await retrieveCsrfToken()

    setError('')

    return sendTradeApplyRequest(props)
      .then((response) => {
        trackTradeProgram()
        return response.data
      })
      .catch((error) => {
        if (error.response.status === 422) {
          setError(error.response.data.message)
        }

        throw error
      })
  }

  const uploadTradeDocument = async ({ setError, setStatus, ...props }: UploadTradeDocumentProps) => {
    await retrieveCsrfToken()
    setError('')

    return sendUploadTradeDocumentRequest(props)
      .then((response) => {
        setStatus(response.status)
        return response.data
      })
      .catch((error) => {
        setStatus(error.response.status)
        if (error.response.status === 422) {
          setError(error.response.data.message)
        }
      })
  }

  return {
    apply,
    uploadTradeDocument,
  }
}
